'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renderBadges = function renderBadges(badge, os) {
  if (badge && os) {
    return _react2.default.createElement(
      'a',
      {
        href: badge.href,
        'data-pa-click': 'AppBadge-badge' + (badge.fpti ? '-' + badge.fpti : '') + '-' + os,
        className: 'app-badge app-badge--' + os
      },
      _react2.default.createElement(
        'span',
        { className: 'sr-only' },
        badge.text || os
      )
    );
  }
  return null;
};

var AppBadge = function AppBadge(props) {
  var clientInfo = props.clientInfo,
      ios = props.ios,
      android = props.android;


  var clientOS = clientInfo.client_os_type || '';

  var iosBadge = renderBadges(ios, 'apple');
  var androidBadge = renderBadges(android, android && android.store || 'google');

  if (clientOS === 'iPhone' || clientOS === 'iPad') {
    return iosBadge;
  } else if (clientOS === 'Android') {
    return androidBadge;
  }

  return _react2.default.createElement(
    'div',
    null,
    iosBadge,
    androidBadge
  );
};

AppBadge.defaultProps = {
  clientInfo: {
    client_os_type: 'iPhone',
    client_is_mobile: true
  }
};

// ESLint disabled here due to the logic of the code above.
// giving defaultProps of ios, android will accidentally
// make AppBadge show all badges in some circumstances (i.e in PC browser).
/* eslint-disable */
AppBadge.propTypes = {
  ios: _propTypes2.default.shape({
    text: _propTypes2.default.string,
    href: _propTypes2.default.string.isRequired,
    fpti: _propTypes2.default.string
  }),
  android: _propTypes2.default.shape({
    text: _propTypes2.default.string,
    href: _propTypes2.default.string.isRequired,
    store: _propTypes2.default.oneOf(['google', 'android-store']),
    fpti: _propTypes2.default.string
  }),
  clientInfo: _propTypes2.default.shape({
    client_os_type: _propTypes2.default.string.isRequired,
    client_is_mobile: _propTypes2.default.bool.isRequired
  })
};
/* eslint-enable */
exports.default = AppBadge;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/atoms/app-badges/jsx/AppBadge.js
// module id = 404
// module chunks = 4